export default __webpack_public_path__ + "images/getting-started.907140d0d24c182b5fc14a3ec0f7e8a0.png";